import { ProfitReport } from '../../../models';

export const getProfitReport = (data: any): ProfitReport => {
  return {
    deliveries: {
      count: data.deliveries.count,
      basePrice: data.deliveries.base_price,
      total: data.deliveries.total,
    },
    schedules: {
      count: data.schedules.count,
      basePrice: data.schedules.base_price,
      total: data.schedules.total,
    },
    pickups: {
      count: data.pickups.count,
      basePrice: data.pickups.base_price,
      total: data.pickups.total,
    },
    workingHours: {
      count: data.working_hours.count,
      basePrice: data.working_hours.base_price,
      total: data.working_hours.total,
    },
    total: data.total
  };
}

